import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import html2canvas from 'html2canvas';
import './QuoteCalculator.css';

const RENTAL_OPTIONS = [
  { id: 'morning', label: '오전 타임', note: '10:00 ~ 14:30 · 4시간 30분', price: 5500000 },
  { id: 'afternoon', label: '오후 타임', note: '17:30 ~ 22:00 · 4시간 30분', price: 5500000 },
  { id: 'allday', label: '올데이', note: '13:00 ~ 20:00 · 7시간 단독 사용', price: 8000000 },
];

const INCLUDED_SERVICES = [
  { label: '음향 · 빔프로젝터 · 마이크 2개 렌탈', note: '예식 진행에 필요한 기본 장비 일체' },
  { label: '음향 엔지니어 상주 + 예식 BGM 운영', note: '전문 엔지니어가 현장에서 사운드를 운영합니다' },
  { label: '홍익대학교 주차장 3시간 무료', note: '최대 30대까지 주차 가능' },
  { label: '웰컴보드 스타일링', note: '신랑신부 이름 · 예식 정보를 담은 웰컴보드' },
  { label: '본식 전 웨딩 스냅 촬영 (1시간)', note: '예식 전 현장에서 스냅 촬영을 진행합니다' },
];

const AV_OPTIONS = [
  { id: 'av_rental', label: '음향 · 빔프로젝터 · 마이크 2개 렌탈', note: '예식 진행에 필요한 기본 장비 일체', price: 0, included: true },
  { id: 'av_engineer', label: '음향 엔지니어 상주 + 예식 BGM 운영', note: '전문 엔지니어가 현장에서 사운드를 운영합니다', price: 0, included: true },
  { id: 'prewedding_video', label: '식전 상영 영상 제작', note: '보내주신 사진·영상으로 식전 상영용 영상을 제작합니다', price: 800000 },
];

const PARTNER_OPTIONS = [
  { id: 'catering', icon: '🍽', label: '케이터링', note: '인당 5만~8만원 · 하객 수 기준 자동 계산', perPersonMin: 50000, perPersonMax: 80000 },
  { id: 'photo', icon: '📷', label: '스냅 · 영상 촬영', note: '본식 스냅 + 영상 구성', min: 1500000, max: 2500000 },
  { id: 'prewedding', icon: '🎬', label: '식전 상영 영상 제작', note: '보내주신 사진·영상으로 식전 상영용 영상 편집', min: 800000, max: 800000 },
  { id: 'mc', icon: '🎤', label: '전문 사회자', note: '예식 진행 전문 사회자', min: 300000, max: 400000 },
  { id: 'helper', icon: '👗', label: '웨딩 헬퍼', note: '신부 드레스 · 동선 케어', min: 150000, max: 250000 },
];

const FLOWER_OPTIONS = [
  { id: 'none', label: '선택 안 함', note: '플라워 데코를 포함하지 않습니다', price: 0 },
  { id: 'basic', label: '기본', note: '웰컴보드 + 테이블 센터피스 + 버진로드', price: 4500000 },
  { id: 'highend', label: '하이엔드', note: '기본 구성 + 아치 + 드레이프 포토존 + 커스터마이징 연출', price: 8500000 },
];

function formatKRW(won) {
  if (won === 0) return '0원';
  const man = Math.floor(won / 10000);
  if (man >= 10000) {
    const eok = Math.floor(man / 10000);
    const rest = man % 10000;
    return rest === 0 ? `${eok}억원` : `${eok}억 ${rest.toLocaleString()}만원`;
  }
  return `${man.toLocaleString()}만원`;
}

function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
}

function QuoteCalculator() {
  const [rental, setRental] = useState('morning');
  const [avSelected, setAvSelected] = useState({});
  const [wineTable, setWineTable] = useState(false);
  const [moodDirecting, setMoodDirecting] = useState(false);
  const [welcomeWine] = useState(true);
  const [wineType, setWineType] = useState('red');
  const [wineBottles, setWineBottles] = useState(12);
  const [corkage, setCorkage] = useState(0);
  const [guestCount, setGuestCount] = useState(100);
  const [partnerSelected, setPartnerSelected] = useState({});
  const [flower, setFlower] = useState('none');
  const [showQuote, setShowQuote] = useState(false);
  const [quoteNo, setQuoteNo] = useState('');
  const [showLead, setShowLead] = useState(false);
  const [groomName, setGroomName] = useState('');
  const [brideName, setBrideName] = useState('');
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);
  const quoteRef = useRef(null);

  const toggleAv = (id) => setAvSelected((p) => ({ ...p, [id]: !p[id] }));
  const togglePartner = (id) => setPartnerSelected((p) => ({ ...p, [id]: !p[id] }));

  const venueTotal = (() => {
    let total = 0;
    const r = RENTAL_OPTIONS.find((o) => o.id === rental);
    if (r) total += r.price;
    AV_OPTIONS.forEach((o) => { if (avSelected[o.id]) total += o.price; });
    if (wineTable) total += 2000000;
    if (moodDirecting) total += 4000000;
    if (welcomeWine) total += wineBottles * 60000;
    total += corkage * 30000;
    return total;
  })();

  const partnerRange = (() => {
    let min = 0, max = 0, hasQuoteOnly = false;
    PARTNER_OPTIONS.forEach((o) => {
      if (!partnerSelected[o.id]) return;
      if (o.quoteOnly) { hasQuoteOnly = true; return; }
      if (o.perPersonMin) {
        min += o.perPersonMin * guestCount;
        max += o.perPersonMax * guestCount;
      } else {
        min += o.min;
        max += o.max;
      }
    });
    const f = FLOWER_OPTIONS.find((o) => o.id === flower);
    if (f && f.price > 0) { min += f.price; max += f.price; }
    return { min, max, hasQuoteOnly };
  })();

  // 견적서에 들어갈 항목 리스트 생성
  const venueItems = (() => {
    const items = [];
    const r = RENTAL_OPTIONS.find((o) => o.id === rental);
    if (r) items.push({ label: `대관 · ${r.label}`, value: formatKRW(r.price) });
    AV_OPTIONS.forEach((o) => { if (!o.included && avSelected[o.id]) items.push({ label: o.label, value: formatKRW(o.price) }); });
    if (wineTable) items.push({ label: '와인 & 디저트 테이블', value: formatKRW(2000000) });
    if (moodDirecting) items.push({ label: '포에트 무드 디렉팅', value: formatKRW(4000000) });
    if (welcomeWine) {
      const typeLabel = wineType === 'red' ? '레드' : wineType === 'white' ? '화이트' : '샴페인';
      items.push({ label: `웰컴 와인 (${typeLabel}) ${wineBottles}병`, value: formatKRW(wineBottles * 60000) });
    }
    if (corkage > 0) items.push({ label: `와인 콜키지 ${corkage}병`, value: formatKRW(corkage * 30000) });
    return items;
  })();

  const partnerItems = (() => {
    const items = [];
    PARTNER_OPTIONS.forEach((o) => {
      if (!partnerSelected[o.id]) return;
      if (o.quoteOnly) { items.push({ label: o.label, value: '맞춤 견적' }); return; }
      if (o.perPersonMin) {
        items.push({ label: `${o.label} (${guestCount}명)`, value: `${formatKRW(o.perPersonMin * guestCount)} ~ ${formatKRW(o.perPersonMax * guestCount)}` });
      } else {
        items.push({ label: o.label, value: o.min === o.max ? formatKRW(o.min) : `${formatKRW(o.min)} ~ ${formatKRW(o.max)}` });
      }
    });
    const f = FLOWER_OPTIONS.find((o) => o.id === flower);
    if (f && f.price > 0) items.push({ label: `플라워 · 데코 (${f.label})`, value: formatKRW(f.price) });
    return items;
  })();

  const openQuote = () => {
    const d = new Date();
    const ymd = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
    const hms = `${String(d.getHours()).padStart(2, '0')}${String(d.getMinutes()).padStart(2, '0')}${String(d.getSeconds()).padStart(2, '0')}`;
    setQuoteNo(`GP-${ymd}-${hms}`);
    setShowQuote(true);
  };
  const closeQuote = () => setShowQuote(false);

  const buildSheetData = () => {
    const r = RENTAL_OPTIONS.find((o) => o.id === rental);
    const avText = AV_OPTIONS.filter((o) => avSelected[o.id]).map((o) => o.label).join(', ');
    const wineAddArr = [];
    if (welcomeWine) {
      const typeLabel = wineType === 'red' ? '레드' : wineType === 'white' ? '화이트' : '샴페인';
      wineAddArr.push(`웰컴와인 ${typeLabel} ${wineBottles}병`);
    }
    if (corkage > 0) wineAddArr.push(`콜키지 ${corkage}병`);
    const f = FLOWER_OPTIONS.find((o) => o.id === flower);
    const partnerName = (id) => {
      const o = PARTNER_OPTIONS.find((x) => x.id === id);
      return partnerSelected[id] ? 'O' : '';
    };
    return {
      quoteNo,
      groomName,
      brideName,
      phone,
      rental: r ? r.label : '',
      av: avText,
      wineTable: wineTable ? '와인&디저트 테이블' : '',
      wineAdd: wineAddArr.join(', '),
      flower: f ? f.label : '',
      guestCount: String(guestCount),
      catering: partnerName('catering'),
      photo: partnerName('photo'),
      mc: partnerName('mc'),
      helper: partnerName('helper'),
      venueTotal: formatKRW(venueTotal),
      partnerRange: partnerRange.min === 0 && partnerRange.max === 0
        ? (partnerRange.hasQuoteOnly ? '맞춤견적' : '-')
        : `${formatKRW(partnerRange.min)}~${formatKRW(partnerRange.max)}`,
    };
  };

  const sendToSheet = async () => {
    try {
      await fetch('/.netlify/functions/submit-quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildSheetData()),
      });
    } catch (e) {
      // 시트 저장 실패해도 이미지 저장은 진행
    }
  };

  const handleSave = async () => {
    setSaving(true);
    await sendToSheet();
    await saveImage();
    setSaving(false);
    setShowLead(false);
  };

  const saveImage = async () => {
    if (!quoteRef.current) return;
    try {
      const canvas = await html2canvas(quoteRef.current, { scale: 2, backgroundColor: '#ffffff' });
      const link = document.createElement('a');
      link.download = `가든포에트_예상견적_${todayStr()}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (e) {
      alert('이미지 저장 중 문제가 발생했어요. 스크린샷으로 저장해주세요.');
    }
  };

  return (
    <div className="qc-page">
      <div className="qc-hero">
        <h1 className="page-hero-title">PRICING</h1>
        <p className="hero-subtitle">Craft Your Celebration</p>
      </div>

      <div className="qc-intro">
        <p className="qc-intro-lead">당신의 결혼식은 특별해야 합니다.</p>
        <p>
          형식적인 웨딩홀이 아닌, 300평 유럽 하우스에서.<br />
          많은 사람이 아닌, 소중한 분들과 함께.<br />
          형식적인 예식이 아닌, 당신만의 이야기로.
        </p>
        <p>
          Garden Poète는 70-200명의 손님을 위한<br />
          프라이빗 하우스 웨딩을 제안합니다.
        </p>
      </div>

      <div className="qc-container">

        <section className="qc-section">
          <div className="qc-section-label">대관</div>
          <div className="qc-section-desc">예식 타임을 선택해주세요. 예식 2시간 전, 케이터링 세팅과 함께하는 서비스 타임이 포함됩니다.</div>
          <div className="qc-card">
            {RENTAL_OPTIONS.map((o) => (
              <label key={o.id} className="qc-option">
                <input type="radio" name="rental" checked={rental === o.id} onChange={() => setRental(o.id)} />
                <div className="qc-option-body">
                  <div className="qc-option-title">{o.label}</div>
                  <div className="qc-option-note">{o.note}</div>
                </div>
                <div className="qc-option-price">{formatKRW(o.price)}</div>
              </label>
            ))}
          </div>
        </section>

        <section className="qc-section">
          <div className="qc-section-label">대관에 포함된 서비스</div>
          <div className="qc-section-desc">대관 시 아래 서비스가 무료로 제공됩니다.</div>
          <div className="qc-card">
            {INCLUDED_SERVICES.map((s, i) => (
              <div key={i} className="qc-option qc-option-included">
                <div className="qc-option-body">
                  <div className="qc-option-title">{s.label}</div>
                  <div className="qc-option-note">{s.note}</div>
                </div>
                <div className="qc-option-badge">기본 제공</div>
              </div>
            ))}
          </div>
        </section>

        <section className="qc-section">
          <div className="qc-section-label">포에트 무드 디렉팅</div>
          <div className="qc-section-desc">파티 전체의 무드를 기획하고 완성하는 프리미엄 디렉팅 서비스입니다.</div>
          <div className="qc-card">
            <label className="qc-option">
              <input type="checkbox" checked={moodDirecting} onChange={() => setMoodDirecting(!moodDirecting)} />
              <div className="qc-option-body">
                <div className="qc-option-title">포에트 무드 디렉팅</div>
                <div className="qc-option-note">음악 큐레이션 · DJ + 테이블 연출(커트러리·식기·글라스) + 양초·조명 연출 + 소품 스타일링 + 정원 조경 연출 + 전문 연출 인력</div>
              </div>
              <div className="qc-option-price">{formatKRW(4000000)}</div>
            </label>
          </div>
        </section>

        <section className="qc-section">
          <div className="qc-section-label">웰컴 와인 &amp; 애프터파티 디저트</div>
          <div className="qc-section-desc">원하시는 항목을 선택해 애프터파티를 완성하세요.</div>
          <div className="qc-card">
            <div className="qc-option qc-option-included">
              <div className="qc-option-body">
                <div className="qc-option-title">웰컴 와인 <span className="qc-inline-badge">기본 포함</span></div>
                <div className="qc-option-note">소중한 하객분들을 맞이하는 가든포에트의 기본 예우입니다. 모든 예식에 웰컴 와인 12병이 포함됩니다.</div>
              </div>
              <div className="qc-option-price">{formatKRW(wineBottles * 60000)}</div>
            </div>
            {true && (
              <>
                <div className="qc-wine-types">
                  {[['red','레드'],['white','화이트'],['champagne','샴페인']].map(([val, lbl]) => (
                    <label key={val} className={`qc-wine-type ${wineType === val ? 'active' : ''}`}>
                      <input type="radio" name="wineType" checked={wineType === val} onChange={() => setWineType(val)} />
                      <span>{lbl}</span>
                    </label>
                  ))}
                </div>
                <div className="qc-qty-row">
                  <div className="qc-option-body">
                    <div className="qc-option-title">와인 수량</div>
                    <div className="qc-option-note">병당 6만원 · 최소 12병</div>
                  </div>
                  <div className="qc-qty-control">
                    <button type="button" onClick={() => setWineBottles(Math.max(12, wineBottles - 1))}>−</button>
                    <input type="number" value={wineBottles} min="12" onChange={(e) => setWineBottles(Math.max(12, parseInt(e.target.value || '12')))} />
                    <button type="button" onClick={() => setWineBottles(wineBottles + 1)}>+</button>
                  </div>
                </div>
              </>
            )}
            <label className="qc-option">
              <input type="checkbox" checked={wineTable} onChange={() => setWineTable(!wineTable)} />
              <div className="qc-option-body">
                <div className="qc-option-title">와인 &amp; 디저트 테이블</div>
                <div className="qc-option-note">2단 커스터마이징 수제케이크 + 샴페인 10병 + 디저트</div>
              </div>
              <div className="qc-option-price">{formatKRW(2000000)}</div>
            </label>
            <div className="qc-qty-row">
              <div className="qc-option-body">
                <div className="qc-option-title">와인 콜키지</div>
                <div className="qc-option-note">외부 와인 반입 시 · 병당 3만원</div>
              </div>
              <div className="qc-qty-control">
                <button type="button" onClick={() => setCorkage(Math.max(0, corkage - 1))}>−</button>
                <input type="number" value={corkage} min="0" onChange={(e) => setCorkage(Math.max(0, parseInt(e.target.value || '0')))} />
                <button type="button" onClick={() => setCorkage(corkage + 1)}>+</button>
              </div>
            </div>
          </div>
        </section>

        <section className="qc-section">
          <div className="qc-section-label">제휴 서비스</div>
          <div className="qc-section-desc">필요한 항목을 선택하면 예상 범위가 아래 합계에 반영됩니다. 실제 금액은 업체·구성에 따라 달라지며, 상담 시 정확히 안내드립니다.</div>

          <div className="qc-card">
            <div className="qc-qty-row">
              <div className="qc-option-body">
                <div className="qc-option-title">예상 하객 수</div>
                <div className="qc-option-note">케이터링 비용 계산에 사용됩니다</div>
              </div>
              <div className="qc-qty-control">
                <button type="button" onClick={() => setGuestCount(Math.max(0, guestCount - 10))}>−</button>
                <input type="number" value={guestCount} min="0" onChange={(e) => setGuestCount(Math.max(0, parseInt(e.target.value || '0')))} />
                <button type="button" onClick={() => setGuestCount(guestCount + 10)}>+</button>
              </div>
            </div>
          </div>

          <div className="qc-flower-label">플라워 · 데코</div>
          <div className="qc-card">
            {FLOWER_OPTIONS.map((o) => (
              <label key={o.id} className="qc-option">
                <input type="radio" name="flower" checked={flower === o.id} onChange={() => setFlower(o.id)} />
                <div className="qc-option-body">
                  <div className="qc-option-title">{o.label}</div>
                  <div className="qc-option-note">{o.note}</div>
                </div>
                <div className="qc-option-price qc-partner-price">{o.price > 0 ? formatKRW(o.price) : '—'}</div>
              </label>
            ))}
          </div>

          <div className="qc-flower-label">기타 제휴 서비스</div>
          <div className="qc-card">
            {PARTNER_OPTIONS.map((o) => {
              let priceText;
              if (o.quoteOnly) priceText = '맞춤 견적';
              else if (o.perPersonMin) priceText = `${formatKRW(o.perPersonMin * guestCount)} ~ ${formatKRW(o.perPersonMax * guestCount)}`;
              else priceText = o.min === o.max ? formatKRW(o.min) : `${formatKRW(o.min)} ~ ${formatKRW(o.max)}`;
              return (
                <label key={o.id} className="qc-option">
                  <input type="checkbox" checked={!!partnerSelected[o.id]} onChange={() => togglePartner(o.id)} />
                  <div className="qc-option-body">
                    <div className="qc-option-title">{o.label}</div>
                    <div className="qc-option-note">{o.note}</div>
                  </div>
                  <div className="qc-option-price qc-partner-price">{priceText}</div>
                </label>
              );
            })}
          </div>

          <p className="qc-partner-note">
            제휴 서비스 예상 금액은 참고용 범위이며 베뉴 직접 합계와 분리되어 표시됩니다.
            각 업체의 서비스 과실에 대한 책임은 해당 업체에 있습니다.
          </p>
        </section>

      </div>

      {showQuote && (
        <div className="qc-modal-overlay" onClick={closeQuote}>
          <div className="qc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="qc-quote-scroll">
            <div className="qc-quote-sheet" ref={quoteRef}>
              <div className="qc-quote-head">
                <div className="qc-quote-brand">GARDEN POÈTE</div>
                <div className="qc-quote-brand-sub">since 2019</div>
                <div className="qc-quote-rule"></div>
                <div className="qc-quote-title-en">ESTIMATE</div>
                <div className="qc-quote-title-ko">예상 견적서</div>
              </div>

              <div className="qc-quote-meta">
                <div className="qc-quote-meta-row"><span>견적번호</span><span>{quoteNo}</span></div>
                <div className="qc-quote-meta-row"><span>발행일</span><span>{todayStr()}</span></div>
              </div>

              <div className="qc-quote-section-title">VENUE · 베뉴 직접 제공</div>
              <div className="qc-quote-lines">
                {venueItems.map((it, i) => (
                  <div key={i} className="qc-quote-line">
                    <span className="qc-quote-line-label">{it.label}</span>
                    <span className="qc-quote-line-dots"></span>
                    <span className="qc-quote-line-value">{it.value}</span>
                  </div>
                ))}
              </div>
              <div className="qc-quote-subtotal">
                <span>베뉴 직접 합계</span><span>{formatKRW(venueTotal)}</span>
              </div>

              {partnerItems.length > 0 && (
                <>
                  <div className="qc-quote-section-title">PARTNERS · 제휴 서비스 (예상)</div>
                  <div className="qc-quote-lines">
                    {partnerItems.map((it, i) => (
                      <div key={i} className="qc-quote-line">
                        <span className="qc-quote-line-label">{it.label}</span>
                        <span className="qc-quote-line-dots"></span>
                        <span className="qc-quote-line-value">{it.value}</span>
                      </div>
                    ))}
                  </div>
                  <div className="qc-quote-subtotal qc-quote-subtotal-partner">
                    <span>제휴 예상 합계</span>
                    <span>
                      {partnerRange.min === 0 && partnerRange.max === 0
                        ? '맞춤 견적'
                        : `${formatKRW(partnerRange.min)} ~ ${formatKRW(partnerRange.max)}`}
                      {partnerRange.hasQuoteOnly && partnerRange.max > 0 ? ' +' : ''}
                    </span>
                  </div>
                </>
              )}

              <div className="qc-quote-note">
                본 견적은 예상 금액이며, 실제 견적은 상담을 통해 확정됩니다.<br />
                제휴 서비스의 품질·하자 책임은 각 제휴 업체에 있습니다.
              </div>

              <div className="qc-quote-footer">
                <div className="qc-quote-footer-line">서울시 마포구 와우산로14길 12, 가든포에트</div>
                <div className="qc-quote-footer-line">hiflow21@naver.com · garden-poete.netlify.app · @garden_poete</div>
              </div>
            </div>

            {showLead && (
              <div className="qc-lead">
                <div className="qc-lead-title">견적서를 저장하시려면 정보를 입력해주세요</div>
                <div className="qc-lead-desc">남겨주신 정보로 더 정확한 상담을 도와드릴 수 있어요.</div>
                <div className="qc-lead-fields">
                  <input type="text" placeholder="신랑 이름" value={groomName} onChange={(e) => setGroomName(e.target.value)} />
                  <input type="text" placeholder="신부 이름" value={brideName} onChange={(e) => setBrideName(e.target.value)} />
                  <input type="tel" placeholder="연락처" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </div>
                <button className="qc-lead-submit" onClick={handleSave} disabled={saving}>
                  {saving ? '저장 중...' : '견적서 저장하기'}
                </button>
              </div>
            )}
            </div>

            <div className="qc-modal-actions">
              <button className="qc-modal-save" onClick={() => setShowLead(true)}>이미지로 저장</button>
              <button className="qc-modal-close" onClick={closeQuote}>닫기</button>
            </div>
          </div>
        </div>
      )}

      <div className="qc-total-bar">
        <div className="qc-total-inner">
          <div className="qc-total-figures">
            <div className="qc-total-block">
              <div className="qc-total-label">베뉴 직접</div>
              <div className="qc-total-amount">{formatKRW(venueTotal)}</div>
            </div>
            <div className="qc-total-block qc-total-partner">
              <div className="qc-total-label">제휴 예상</div>
              <div className="qc-total-amount">
                {partnerRange.min === 0 && partnerRange.max === 0
                  ? (partnerRange.hasQuoteOnly ? '맞춤' : '—')
                  : `${formatKRW(partnerRange.min)}~${formatKRW(partnerRange.max)}`}
              </div>
            </div>
          </div>
          <div className="qc-total-actions">
            <button className="qc-total-cta" onClick={openQuote}>견적 내역</button>
            <Link to="/reservation" className="qc-total-link">예약 신청</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuoteCalculator;
